/* BB3 · Tests paliers + upsell
   Module de test : ne modifie pas bb3.js. Il relit l'état de BB3
   (localStorage « bb3_state_v2 ») après chaque rendu et repose ses
   éléments. Variantes : ?pal=A|B|C|0 & ?ups=A|B|C|0 */
(function () {
  'use strict';
  var C = window.BB3T || {};
  var root = document.getElementById('bb3');
  if (!root) return;

  /* ── Variantes : URL > mémoire de session > réglage ── */
  var q = new URLSearchParams(location.search);
  function pick(k, def) {
    var v = (q.get(k) || '').toUpperCase();
    if (/^[ABC0]$/.test(v)) { try { sessionStorage.setItem('bb3t_' + k, v); } catch (e) {} return v; }
    try { v = sessionStorage.getItem('bb3t_' + k); } catch (e) { v = null; }
    return v || def || '0';
  }
  var PAL = pick('pal', C.pal), UPS = pick('ups', C.ups);
  /* Versions abouties de « Paliers A + Upsell B » : ?v=1|2|3|4 (0 = off) */
  var V = (function () {
    var v = q.get('v');
    if (v !== null && /^[0-8]$/.test(v)) { try { sessionStorage.setItem('bb3t_v', v); } catch (e) {} }
    else { try { v = sessionStorage.getItem('bb3t_v'); } catch (e) { v = null; } }
    return +(v || C.v || 0);
  })();
  if (V === 1) { PAL = 'A'; UPS = 'B'; }
  else if (V === 7) { PAL = 'Q'; UPS = '0'; }
  else if (V >= 2) { PAL = V === 3 ? 'P' : 'A'; UPS = 'K'; }
  var MINI = V === 6 || V === 8;   /* versions minimales : pastille compteur + une seule case */
  var panOuvert = false;  /* version 4 : panneau « avantages » déplié */
  var OUTIL = (window.BB3_CONFIG && window.BB3_CONFIG.outil) || null;
  var LIV = (window.BB3_CONFIG && +window.BB3_CONFIG.livraisonOfferte) || 5000;
  var P1 = 10, P2 = +C.p2 || 15, P3 = +C.p3 || 18;
  var PROD = C.produit;
  if (!PROD || !PROD.dispo) UPS = '0';
  var PRIX_UP = PROD ? Math.round(PROD.prix * (100 - C.pct) / 100) : 0;

  var upChoisi = false;   /* la cliente a dit oui à l'upsell */
  var upVu = false;       /* variante C : la proposition a déjà été faite */
  var passe = false;      /* clic « Valider » relancé par nous */
  var dernierNb = 0;      /* B : pour ne faire glisser le rail qu'à l'ajout */

  function $(id) { return document.getElementById(id); }
  function eur(c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; }
  function fill(t, o) { return String(t || '').replace(/\[(\w+)\]/g, function (m, k) { return o[k] !== undefined ? o[k] : m; }); }

  function etat() {
    try {
      var d = JSON.parse(localStorage.getItem('bb3_state_v2') || '{}');
      return { nb: (d.pose || []).length, first: (d.mode || 'first') === 'first', outil: !!d.outil };
    } catch (e) { return { nb: 0, first: true }; }
  }

  /* ── Texte du palier suivant (à partir de 10 charms) ── */
  function message(nb) {
    if (nb < P1) return null;
    if (nb < P2) return fill(C.t1, { n: '<b>' + (P2 - nb) + '</b>', cadeau: C.p2Nom });
    if (nb < P3) return fill(C.t2, { n: '<b>' + (P3 - nb) + '</b>', cadeau: C.p3Nom, cadeau1: cap(C.p2Nom) });
    return C.t3;
  }
  function cap(s) { s = String(s || ''); return s.charAt(0).toUpperCase() + s.slice(1); }

  /* ── Barres ── */
  /* Position sur la barre. Versions 2+ : échelle par paliers (10 → 40 %, 15 → 70 %,
     18 → 100 %) pour que les étapes et leurs noms ne se chevauchent pas sur téléphone. */
  function pos(n) {
    if (V < 2) return Math.min(100, n / P3 * 100);
    if (n <= P1) return n / P1 * 40;
    if (n <= P2) return 40 + (n - P1) / (P2 - P1) * 30;
    return Math.min(100, 70 + (n - P2) / (P3 - P2) * 30);
  }
  function barreEtapes(nb) {          /* A : une barre, trois étapes */
    var p = pos(nb);
    function pt(v, ic) {
      var ok = nb >= v;
      return '<span class="t-pt' + (ok ? ' ok' : '') + '" style="left:' + pos(v) + '%">' + (ok ? '✓' : ic) + '</span>';
    }
    return '<div class="t-etapes"><i style="width:' + p + '%"></i>' + pt(P1, '🎁') + pt(P2, '🎁') + pt(P3, '★') + '</div>';
  }
  function barreSuivante(nb) {        /* B : la barre vise le prochain palier */
    var a, b;
    if (nb < P1) { a = 0; b = P1; } else if (nb < P2) { a = P1; b = P2; } else if (nb < P3) { a = P2; b = P3; } else { a = 0; b = 1; nb = 1; }
    var p = Math.min(100, (nb - a) / (b - a) * 100);
    return '<i style="width:' + p + '%;background:var(--fonce,#E96D8D)"></i>';
  }
  function barreMaillons(nb) {        /* C : 18 petits maillons */
    var h = '';
    for (var i = 1; i <= P3; i++) {
      var cl = i <= nb ? ' on' : '';
      var cad = (i === P1 || i === P2 || i === P3) ? ' cad' : '';
      h += '<span class="t-m' + cl + cad + '">' + ((i === P2 || i === P3) && i > nb ? '🎁' : '') + '</span>';
    }
    return '<div class="t-maillons">' + h + '</div>';
  }

  /* Version 2 : noms des paliers sous la barre */
  function etiquettes(nb) {
    function e(v, t, cls) { return '<span class="t-lab' + (nb >= v ? ' ok' : '') + (cls || '') + '" style="left:' + pos(v) + '%">' + t + '</span>'; }
    return '<div class="t-labs">' + e(P1, 'Bracelet') + e(P2, '1 charm') + e(P3, '2 charms', ' fin') + '</div>';
  }
  /* Livraison offerte : on lit ce que BB3 affiche dans son total */
  function livOk() { var t = $('mtot') || $('tot'); return !!(t && t.querySelector('.ship.ok')); }
  /* Les avantages, du plus proche au plus lointain */
  function avantages(s) {
    function r(v) { var n = v - s.nb; return n + ' charm' + (n > 1 ? 's' : ''); }
    return [
      { ok: s.nb >= P1, court: s.nb >= P1 ? '✓ Bracelet' : '🎁 Bracelet · +' + (P1 - s.nb),
        long: s.nb >= P1 ? 'Bracelet offert' : 'Bracelet offert dans ' + r(P1) },
      { ok: livOk(), court: livOk() ? '✓ Livraison' : '🚚 Livraison dès ' + Math.round(LIV / 100) + ' €',
        long: livOk() ? 'Livraison offerte' : 'Livraison offerte dès ' + Math.round(LIV / 100) + ' €' },
      { ok: s.nb >= P2, court: s.nb >= P2 ? '✓ Charm' : '🎁 ' + cap(C.p2Nom) + ' · +' + (P2 - s.nb),
        long: s.nb >= P2 ? cap(C.p2Nom) : cap(C.p2Nom) + ' dans ' + r(P2) },
      { ok: s.nb >= P3, court: s.nb >= P3 ? '✓ 2ᵉ charm' : '★ ' + cap(C.p3Nom) + ' · +' + (P3 - s.nb),
        long: s.nb >= P3 ? cap(C.p3Nom) : cap(C.p3Nom) + ' dans ' + r(P3) }
    ];
  }
  /* Version 3 : les avantages en pastilles, à la place de la barre */
  function pastilles(s) {
    /* le prochain objectif d'abord, pour qu'il soit toujours visible sur téléphone */
    var av = avantages(s), tri = av.filter(function (a) { return !a.ok; }).concat(av.filter(function (a) { return a.ok; }));
    return '<div class="t-perks">' + tri.map(function (a) {
      return '<span class="t-perk' + (a.ok ? ' ok' : '') + '">' + a.court + '</span>';
    }).join('') + '</div>';
  }

  /* ── Options (outil + bijou) en puces, versions 2 à 4 ── */
  function puce(type, on, img, nom, prix) {
    return '<button type="button" class="t-chip' + (on ? ' on' : '') + '" data-t-chip="' + type + '" aria-pressed="' + on + '">' +
      '<span class="t-ck" aria-hidden="true">' + (on ? '✓' : '') + '</span>' + img +
      '<span class="t-chip-n">' + nom + '</span><span class="t-chip-p">' + prix + '</span></button>';
  }
  function puces(s) {
    var h = '';
    if (OUTIL && OUTIL.dispo !== false) h += puce('outil', s.outil, '<span class="t-chip-i">🔧</span>', 'Outil', '+' + eur(OUTIL.prix || 199));
    if (PROD && s.nb >= (+C.upDes || 0)) h += puce('up', upChoisi, '<img src="' + PROD.img + '" alt="" width="24" height="24">', '<em>−' + C.pct + ' %</em> ' + PROD.nom, eur(PRIX_UP));
    return h ? '<div class="t-chips">' + h + '</div>' : '';
  }
  /* ── Version 7 : « je choisis mon pack, puis je compose » ──
     Une fenêtre d'accueil propose 3 packs ; le pack choisi fixe l'objectif.
     Version 8 : même fenêtre, mais simplement pour expliquer les avantages. */
  var PACKS = [
    { n: 10, nom: 'Pack 10 charms', tag: '', dons: 'Bracelet offert · livraison offerte', offert: 1990 },
    { n: 15, nom: 'Pack 15 charms', tag: 'Populaire', dons: 'Bracelet + outil + charm exclusif offerts', offert: 1990 + 199 + 599 },
    { n: 20, nom: 'Pack 20 charms', tag: 'Meilleure offre', dons: 'Tout le pack 15 + un 2ᵉ bracelet pour une copine', offert: 1990 + 199 + 599 + 1990 }
  ];
  var PRIX_MIN = 499;   /* prix d'un charm, pour l'affichage « dès » */
  function lire(k, d) { try { var v = sessionStorage.getItem(k); return v === null ? d : v; } catch (e) { return d; } }
  function ecrire(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
  var CIBLE = +lire('bb3t_pack', 15);
  function packDe(n) { for (var i = 0; i < PACKS.length; i++) if (PACKS[i].n === n) return PACKS[i]; return PACKS[1]; }
  function barrePack(s) {
    var pk = packDe(CIBLE), ok = s.nb >= pk.n, p = Math.min(100, s.nb / pk.n * 100);
    var txt = ok ? '✓ <b>' + pk.nom + ' complet</b> · ' + pk.dons.toLowerCase()
      : '<b>' + s.nb + '/' + pk.n + '</b> charms · encore ' + (pk.n - s.nb) + ' pour ton pack';
    return '<div class="t-pk-l"><span class="t-pk-t">' + txt + '</span><button type="button" class="t-pk-chg" data-t-intro>Changer</button></div>' +
      '<div class="t-pk-bar"><i style="width:' + p + '%"></i></div>';
  }
  /* Formats de la fenêtre d'accueil : ?f=1..4 */
  var F = (function () {
    var f = q.get('f');
    if (f !== null && /^[1-4]$/.test(f)) { ecrire('bb3t_f', f); return +f; }
    return +lire('bb3t_f', 1);
  })();
  var CDN = 'https://italiancharms.fr/cdn/shop/files/';
  function img(nom, w, cls, alt) { return '<img class="' + (cls || '') + '" src="' + CDN + nom + '&width=' + w + '" alt="' + (alt || '') + '" loading="eager">'; }
  var IMG = {
    porte: 'italian-charm-bracelet-3548622.jpg?v=1776412812',
    kit: '34.png?v=1776868705',
    kit2: 'bracelet-autumn-5842034.png?v=1776941057',
    compose: 'bracelet-bestsellers-899832.png?v=1756986681',
    nu: 'italian-charm-bracelet-7779198.jpg?v=1781829747',
    soleil: 'soleil-dore-suspendu-1773814.png?v=1756986141',
    etoile: 'etoile-3874730.png?v=1756986394'
  };
  var PACK_IMG = { 10: IMG.nu, 15: IMG.kit, 20: IMG.kit2 };
  var NB_BRAC = 'près de 30 000';
  var NOTE = '4,8/5';
  var AVIS = [
    { t: 'J\'ai adoré le fait d\'avoir un bracelet offert pour une commande de charms, de plus la livraison est très rapide.', n: 'Adélie M.' },
    { t: 'Très bien emballé, avec deux vidéos pour expliquer comment positionner les charms. Le bracelet est magnifique !', n: 'Nina T.' },
    { t: 'Les charms sont faciles à mettre et à enlever. J\'en ai même recommandé un pour le faire à mon copain. J\'ADORE', n: 'Cassandra R.' }
  ];
  var ETOILES = '<span class="t-in-st">★★★★★</span>';
  function preuve(cls) {
    return '<div class="t-in-proof ' + (cls || '') + '">' + ETOILES + '<span><b>' + NOTE + '</b> · ' + NB_BRAC + ' bracelets composés</span></div>';
  }
  function puces3() {
    return '<div class="t-in-chips"><span>📦 Expédié sous 24 h</span><span>🇫🇷 Marque française</span><span>↩︎ 14 j pour changer d\'avis</span></div>';
  }
  function avisCarte(a) {
    return '<figure class="t-in-avis">' + ETOILES + '<blockquote>« ' + a.t + ' »</blockquote><figcaption>' + a.n + ' · Trustpilot · achat vérifié</figcaption></figure>';
  }
  function lignesPacks(avecImg) {
    return '<div class="t-in-packs">' + PACKS.map(function (pk) {
      var des = pk.n * PRIX_MIN;
      return '<button type="button" class="t-in-pk' + (avecImg ? ' t-in-pk--img' : '') + (pk.n === CIBLE ? ' on' : '') + '" data-t-pack="' + pk.n + '">' +
        (pk.tag ? '<span class="t-in-tag">' + (pk.tag === 'Populaire' ? '⭐ ' : '') + pk.tag + '</span>' : '') +
        (avecImg ? img(PACK_IMG[pk.n], 160, 't-in-pimg') : '<span class="t-in-r"></span>') +
        '<span class="t-in-x"><b>' + pk.nom + '</b><span>' + pk.dons + '</span></span>' +
        '<span class="t-in-p"><s>' + eur(des + pk.offert) + '</s><b>dès ' + eur(des) + '</b></span></button>';
    }).join('') + '</div>';
  }
  function colonnesPacks() {
    return '<div class="t-in-cols">' + PACKS.map(function (pk) {
      var des = pk.n * PRIX_MIN, eco = Math.round(pk.offert / (des + pk.offert) * 100);
      return '<button type="button" class="t-in-col' + (pk.n === CIBLE ? ' on' : '') + '" data-t-pack="' + pk.n + '">' +
        '<span class="t-in-col-tag">' + (pk.tag || 'Découverte') + '</span>' +
        '<b class="t-in-col-n">' + pk.n + '</b><span class="t-in-col-u">charms</span>' +
        '<span class="t-in-col-eco">−' + eco + ' %</span>' +
        '<s>' + eur(des + pk.offert) + '</s><b class="t-in-col-p">dès ' + eur(des) + '</b></button>';
    }).join('') + '</div>' +
    '<p class="t-in-col-dons">🎁 ' + packDe(CIBLE).dons + '</p>';
  }
  function segmentPacks() {
    var pk = packDe(CIBLE), des = pk.n * PRIX_MIN;
    return '<div class="t-in-seg">' + PACKS.map(function (p) {
      return '<button type="button" class="' + (p.n === CIBLE ? 'on' : '') + '" data-t-pack="' + p.n + '">' + p.n + ' charms' + (p.tag === 'Populaire' ? ' ⭐' : '') + '</button>';
    }).join('') + '</div>' +
    '<div class="t-in-segbox">' + img(PACK_IMG[pk.n], 240, 't-in-segimg') +
      '<div><b>' + pk.nom + '</b><span>' + pk.dons + '</span><span class="t-in-p t-in-p--l"><s>' + eur(des + pk.offert) + '</s><b>dès ' + eur(des) + '</b></span></div></div>';
  }
  var BTN_GO7 = '<button type="button" class="t-f-oui" data-t-go>Commencer mon bracelet</button><button type="button" class="t-f-non" data-t-libre>Je compose librement</button>';
  var BTN_GO8 = '<button type="button" class="t-f-oui" data-t-go>C\'est parti</button>';
  var ETAPES = '<ol class="t-in-steps"><li><b>Choisis ta couleur</b> de bracelet</li><li><b>Ajoute tes charms</b> un par un, tu les vois en direct</li><li><b>Valide</b>, on expédie sous 24 h</li></ol>';
  var CADEAUX = '<div class="t-in-gifts"><p>🎁 Plus tu en mets, plus on t\'offre</p>' +
    '<div><b>10 charms</b><span>Bracelet offert + livraison offerte</span></div>' +
    '<div><b>12 charms</b><span>+ un charm exclusif offert</span></div>' +
    '<div><b>15 charms</b><span>+ un 2ᵉ charm exclusif offert</span></div></div>';
  function corpsIntro() {
    if (V === 7) {
      if (F === 2) return '<div class="t-in-hero">' + img(IMG.porte, 800, 't-in-heroimg') + '<div class="t-in-herotxt"><b>Crée ton bracelet</b><span>' + NB_BRAC + ' déjà composés</span></div></div>' +
        '<p class="t-in-s t-in-s--c">Choisis ton pack, puis ajoute tes charms un par un.</p>' + colonnesPacks() + BTN_GO7 + preuve('t-in-proof--c');
      if (F === 3) return '<div class="t-in-stat"><b>' + NB_BRAC.replace('près de ', '') + '</b><span>bracelets déjà composés ici</span>' + ETOILES + '</div>' +
        '<p class="t-in-t">Crée le tien</p><p class="t-in-s">Choisis ton pack, puis ajoute tes charms un par un.</p>' + lignesPacks(true) + BTN_GO7 +
        '<p class="t-in-quote">« ' + AVIS[0].t + ' » <span>— ' + AVIS[0].n + ', Trustpilot</span></p>';
      if (F === 4) return '<p class="t-in-t">Crée ton bracelet</p>' + preuve() + segmentPacks() + BTN_GO7 +
        '<div class="t-in-carr">' + AVIS.map(avisCarte).join('') + '</div>';
      return preuve('t-in-proof--top') + '<p class="t-in-t">Crée ton bracelet</p><p class="t-in-s">Choisis ton pack, puis ajoute tes charms un par un.</p>' + lignesPacks(false) + BTN_GO7 + puces3();
    }
    if (F === 2) return '<div class="t-in-hero">' + img(IMG.porte, 800, 't-in-heroimg') + '<div class="t-in-herotxt"><b>Ton bracelet, maillon par maillon</b><span>' + NB_BRAC + ' déjà composés</span></div></div>' +
      '<div class="t-in-3"><div><i>1</i><b>Ta couleur</b><span>Or, argent…</span></div><div><i>2</i><b>Tes charms</b><span>Tu les vois en direct</span></div><div><i>3</i><b>Expédié</b><span>sous 24 h</span></div></div>' +
      '<p class="t-in-1l">🎁 <b>Bracelet offert dès 10 charms</b>, et des charms exclusifs offerts à 12 et 15.</p>' + BTN_GO8 + preuve('t-in-proof--c');
    if (F === 3) return '<p class="t-in-t">Plus tu en mets, plus on t\'offre</p><p class="t-in-s">' + NB_BRAC + ' bracelets déjà composés · ' + NOTE + ' ★</p>' +
      '<div class="t-in-ladder">' +
        '<div>' + img(IMG.nu, 160) + '<span><b>10 charms</b>Bracelet offert + livraison offerte</span></div>' +
        '<div>' + img(IMG.soleil, 160) + '<span><b>12 charms</b>+ un charm exclusif offert</span></div>' +
        '<div>' + img(IMG.etoile, 160) + '<span><b>15 charms</b>+ un 2ᵉ charm exclusif offert</span></div></div>' +
      BTN_GO8 + '<p class="t-in-quote">« ' + AVIS[2].t + ' » <span>— ' + AVIS[2].n + ', Trustpilot</span></p>';
    if (F === 4) return '<div class="t-in-mini">' + img(IMG.compose, 300, 't-in-miniimg') + '<p class="t-in-t">Compose ton bracelet</p>' +
      '<p class="t-in-s">Ajoute tes charms un par un, tu vois le résultat en direct.</p>' +
      '<div class="t-in-chips t-in-chips--c"><span>🎁 Bracelet offert dès 10</span><span>📦 Expédié 24 h</span><span>★ ' + NOTE + '</span></div></div>' + BTN_GO8;
    return preuve('t-in-proof--top') + '<p class="t-in-t">Comment ça marche ?</p>' + ETAPES + CADEAUX + BTN_GO8 + puces3();
  }
  function intro() {
    if (document.querySelector('.t-intro')) return;
    var f = document.createElement('div'); f.className = 't-feuille t-intro t-intro--' + V + '-' + F;
    f.innerHTML = '<div class="t-f-fond" data-t-libre></div><div class="t-f-box t-in-box" role="dialog" aria-modal="true">' + corpsIntro() + '</div>';
    document.body.appendChild(f);
    setTimeout(function () { f.classList.add('on'); }, 20);
    f.addEventListener('click', function (e) {
      var pk = e.target.closest('[data-t-pack]');
      if (pk) {
        CIBLE = +pk.dataset.tPack;
        if (F === 2 || F === 4) { var bx = f.querySelector('.t-in-box'), y = bx.scrollTop; bx.innerHTML = corpsIntro(); bx.scrollTop = y; }
        else f.querySelectorAll('[data-t-pack]').forEach(function (x) { x.classList.toggle('on', x === pk); });
        return;
      }
      if (e.target.closest('[data-t-go]') || e.target.closest('[data-t-libre]')) {
        if (e.target.closest('[data-t-libre]') && V === 7) CIBLE = 10;
        ecrire('bb3t_pack', CIBLE); ecrire('bb3t_intro', '1');
        f.classList.remove('on'); setTimeout(function () { f.remove(); }, 250); rendre();
      }
    });
  }

  /* ── Versions 5 et 6 : épurées (compteur + upsell en case à cocher) ── */
  function nbOk(s) { return avantages(s).filter(function (a) { return a.ok; }).length; }
  function compteur(s) {
    return '<button type="button" class="t-pan-btn" data-t-pan aria-expanded="' + panOuvert + '">' +
      '<span>🎁 <b>' + nbOk(s) + '/4</b> avantages débloqués</span><span class="t-pan-c">' + (panOuvert ? 'Masquer' : 'Voir') + '</span></button>';
  }
  function panneau(s) {
    return '<div class="t-pan">' + avantages(s).map(function (a) {
      return '<div class="t-pan-l' + (a.ok ? ' ok' : '') + '"><span class="t-pan-d">' + (a.ok ? '✓' : '') + '</span>' + a.long + '</div>';
    }).join('') + '</div>';
  }
  function ligne(type, on, img, nom, prix) {
    return '<label class="t-up-cb t-case"><input type="checkbox" data-t-case="' + type + '"' + (on ? ' checked' : '') + '>' +
      img + '<span>' + nom + '</span><span class="t-up-p">' + prix + '</span></label>';
  }
  function cases(s) {
    var jonc = PROD && s.nb >= (+C.upDes || 0), h = '';
    var lJonc = jonc ? ligne('up', upChoisi, '<img src="' + PROD.img + '" alt="" width="28" height="28">',
      PROD.nom + ' <em>−' + C.pct + ' %</em>', prixHtml()) : '';
    var lOutil = (OUTIL && OUTIL.dispo !== false) ? ligne('outil', s.outil, '<i class="t-case-i" aria-hidden="true">🔧</i>',
      'Outil à charms', eur(OUTIL.prix || 199)) : '';
    /* V6 : une seule ligne — le jonc dès qu'il est proposé, sinon l'outil */
    if (MINI) h = jonc ? lJonc : lOutil;
    else h = lJonc + lOutil;
    return h ? '<div class="t-cases">' + h + '</div>' : '';
  }
  function poserKit(s) {
    document.querySelectorAll('.t-kit').forEach(function (x) { x.remove(); });
    if (!s.first) { upChoisi = false; return; }
    if (s.nb < (+C.upDes || 0)) upChoisi = false;
    var h = '';
    if (V >= 5) {
      if (V === 5) h += compteur(s);
      if (panOuvert) h += panneau(s);
      h += cases(s);
    } else if (V === 4) {
      var av = avantages(s), n = av.filter(function (a) { return a.ok; }).length;
      h += '<button type="button" class="t-pan-btn" data-t-pan aria-expanded="' + panOuvert + '">' +
        '<span>🎁 <b>' + n + '/' + av.length + '</b> avantages débloqués</span><span class="t-pan-c">' + (panOuvert ? 'Masquer' : 'Voir') + '</span></button>';
      if (panOuvert) h += '<div class="t-pan">' + av.map(function (a) {
        return '<div class="t-pan-l' + (a.ok ? ' ok' : '') + '"><span class="t-pan-d">' + (a.ok ? '✓' : '') + '</span>' + a.long + '</div>';
      }).join('') + '</div>';
      h += puces(s);
    } else {
      h += puces(s);
    }
    if (!h) return;
    [['cta', 't-kit--recap'], ['mcta', 't-kit--sheet']].forEach(function (x) {
      var el = $(x[0]); if (!el) return;
      var d = document.createElement('div'); d.className = 't-kit t-kit--v' + V + ' ' + x[1]; d.innerHTML = h;
      var host = x[0] === 'mcta' ? el.parentNode : el;
      host.parentNode.insertBefore(d, host);
    });
    majCta();
  }

  /* ── Paliers ── */
  function poserPaliers(s) {
    ['jt', 'mjt'].forEach(function (id) {
      var el = $(id); if (!el) return;
      var m = s.first ? message(s.nb) : null;
      if (m) el.innerHTML = '<span class="t-msg">' + m + '</span>';
    });
    ['jbar', 'mjbar'].forEach(function (id) {
      var el = $(id); if (!el || !s.first) return;
      if (PAL === 'A' && MINI) { el.classList.add('t-bar-perso'); el.innerHTML = '<div class="t-bar6">' + barreEtapes(s.nb) +
        '<button type="button" class="t-pill" data-t-pan aria-expanded="' + panOuvert + '">🎁 ' + nbOk(s) + '/4 <span>' + (panOuvert ? '▴' : '▾') + '</span></button></div>'; }
      else if (PAL === 'A') { el.classList.add('t-bar-perso'); el.innerHTML = barreEtapes(s.nb) + (V === 2 ? etiquettes(s.nb) : ''); }
      else if (PAL === 'P') { el.classList.add('t-bar-perso'); el.innerHTML = pastilles(s); }
      else if (PAL === 'Q') { el.classList.add('t-bar-perso'); el.innerHTML = barrePack(s); }
      else if (PAL === 'C') { el.classList.add('t-bar-perso'); el.innerHTML = barreMaillons(s.nb); }
      else if (PAL === 'B' && s.nb >= P1) { el.innerHTML = barreSuivante(s.nb); }
    });
    if (PAL === 'B' && s.first) cadeauxSurRail(s.nb);
    vignetteCadeau(s);
  }

  /* B : 🎁 sur les maillons qui recevront le 15ᵉ et le 18ᵉ charm */
  function cadeauxSurRail(nb) {
    var libres = Array.prototype.filter.call(document.querySelectorAll('#piste .rail > .mv'),
      function (m) { return !m.classList.contains('pris'); });
    [P2, P3].forEach(function (p) {
      var i = p - nb - 1;
      if (i >= 0 && libres[i]) {
        libres[i].classList.add('t-cad');
        var b = document.createElement('span'); b.className = 't-cad-b'; b.textContent = '🎁';
        libres[i].appendChild(b);
      }
    });
    /* Sur téléphone le bracelet déborde : on fait glisser le rail jusqu'au
       prochain cadeau quand un charm vient d'être ajouté. */
    /* BB3 fait d'abord défiler le rail vers le charm ajouté : on passe après lui. */
    if (nb > dernierNb) setTimeout(function () {
      var pz0 = $('piste'), cible0 = document.querySelector('#piste .mv.t-cad');
      if (!pz0 || !cible0 || pz0.scrollWidth <= pz0.clientWidth) return;
      var x = cible0.offsetLeft + cible0.offsetWidth / 2 - pz0.clientWidth / 2;
      if (x > pz0.scrollLeft) pz0.scrollTo({ left: x, behavior: 'smooth' });
    }, 600);
    dernierNb = nb;
    var info = $('t-rail');
    if (!info) { info = document.createElement('p'); info.id = 't-rail'; var pz = $('piste'); if (pz) pz.parentNode.insertBefore(info, pz.nextSibling); }
    var cible = nb < P2 ? P2 : (nb < P3 ? P3 : 0);
    info.hidden = !cible || nb < P1 - 3;
    if (cible) info.innerHTML = fill(C.railTxt, { cadeau: cible === P2 ? C.p2Nom : C.p3Nom, p: cible });
  }

  /* Cadeau débloqué : une vignette 🎁 au bout de la bande de sélection
     (mobile) et une ligne « Offert » dans le récap (ordinateur). */
  function vignetteCadeau(s) {
    var n = !s.first ? 0 : (s.nb >= P3 ? 2 : s.nb >= P2 ? 1 : 0);
    var st = $('selstrip');
    if (st && n && V < 5) for (var i = 0; i < n; i++) {
      var d = document.createElement('div'); d.className = 'sel t-sel-cad'; d.title = cap(C.p2Nom) + ' offert';
      d.innerHTML = '<span>🎁</span>'; st.insertBefore(d, st.children[1] || null);
    }
    var it = $('items');
    if (it && n) {
      var l = document.createElement('div'); l.className = 'it free t-it';
      l.innerHTML = '<span class="it-v t-it-v">🎁</span><span class="it-n">' + cap(n > 1 ? '2 charms offerts' : C.p2Nom) + '</span><span class="it-p">Offert</span>';
      var ref = it.children[1] || null; it.insertBefore(l, ref);
    }
  }

  /* ── Upsell ── */
  function prixHtml() {
    return '<s>' + eur(PROD.prix) + '</s> <b>' + eur(PRIX_UP) + '</b>';
  }
  function bouton(cls) {
    return '<button type="button" class="t-up-btn ' + (cls || '') + (upChoisi ? ' on' : '') + '" data-t-up>' +
      (upChoisi ? C.upAjoute : C.upAjout) + '</button>';
  }
  function poserUpsell(s) {
    var voir = s.first && s.nb >= (+C.upDes || 0);
    var old = document.querySelectorAll('.t-up'); for (var i = 0; i < old.length; i++) old[i].remove();
    if (!voir) { upChoisi = false; return; }
    var sous = fill(C.upSous, { pct: C.pct });
    if (UPS === 'A') {
      var carte = '<img src="' + PROD.img + '" alt="" width="56" height="56" loading="lazy">' +
        '<div class="t-up-txt"><span class="t-up-t">' + C.upTitre + ' <em>· ' + sous + '</em></span>' +
        '<span class="t-up-n">' + PROD.nom + '</span><span class="t-up-p">' + prixHtml() + '</span></div>' + bouton();
      var a = document.createElement('div'); a.className = 't-up t-up--a t-up--page'; a.innerHTML = carte;
      var sc = $('scene'); if (sc) sc.parentNode.insertBefore(a, sc.nextSibling);
      var b = document.createElement('div'); b.className = 't-up t-up--a t-up--recap'; b.innerHTML = carte;
      var tot = $('tot'); if (tot) tot.parentNode.insertBefore(b, tot);
    } else if (UPS === 'B') {
      var ligne = '<label class="t-up-cb"><input type="checkbox" data-t-cb' + (upChoisi ? ' checked' : '') + '>' +
        '<img src="' + PROD.img + '" alt="" width="28" height="28">' +
        '<span>' + PROD.nom + ' <em>−' + C.pct + ' %</em></span><span class="t-up-p">' + prixHtml() + '</span></label>';
      [['cta', 't-up--recap'], ['mcta', 't-up--sheet']].forEach(function (x) {
        var el = $(x[0]); if (!el) return;
        var d = document.createElement('div'); d.className = 't-up t-up--b ' + x[1]; d.innerHTML = ligne;
        var host = x[0] === 'mcta' ? el.parentNode : el;
        host.parentNode.insertBefore(d, host);
      });
    }
    majCta();
  }
  /* Le bouton « Valider » affiche le vrai total, upsell compris */
  function majCta() {
    ['cta', 'mcta'].forEach(function (id) {
      var el = $(id); if (!el || el.disabled) return;
      if (el.dataset.tOut !== el.textContent) el.dataset.tBase = el.textContent;
      var t = el.dataset.tBase || el.textContent, out = t, m = t.match(/(\d[\d\s.]*,\d{2})\s*€/);
      if (m && upChoisi && UPS !== 'C') {
        var v = Math.round(parseFloat(m[1].replace(/[\s.]/g, '').replace(',', '.')) * 100) + PRIX_UP;
        out = t.replace(m[0], eur(v));
      }
      if (el.textContent !== out) el.textContent = out;
      el.dataset.tOut = out;
    });
  }

  /* Variante C : la proposition s'ouvre au clic sur « Valider » */
  function feuille(suite) {
    var f = document.createElement('div'); f.className = 't-feuille';
    f.innerHTML = '<div class="t-f-fond" data-t-non></div><div class="t-f-box" role="dialog" aria-modal="true">' +
      '<p class="t-f-t">' + C.upApresTitre + '</p>' +
      '<div class="t-f-p"><img src="' + PROD.img + '" alt="" width="72" height="72"><div><span class="t-up-n">' + PROD.nom +
      '</span><span class="t-up-p">' + prixHtml() + '</span></div></div>' +
      '<p class="t-f-x">' + fill(C.upApresTxt, { nom: PROD.nom, pct: C.pct }) + '</p>' +
      '<button type="button" class="t-f-oui" data-t-oui>' + C.upAjout + ' · ' + eur(PRIX_UP) + '</button>' +
      '<button type="button" class="t-f-non" data-t-non>' + C.upNon + '</button></div>';
    document.body.appendChild(f);
    setTimeout(function () { f.classList.add('on'); }, 20);
    f.addEventListener('click', function (e) {
      var oui = e.target.closest('[data-t-oui]'), non = e.target.closest('[data-t-non]');
      if (!oui && !non) return;
      upChoisi = !!oui; f.remove(); suite();
    });
  }

  function ajouterUpsell() {
    var url = (window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart/add.js';
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: PROD.vid, quantity: 1, properties: { _upsell: 'bb3-' + UPS } }] }) })
      .catch(function () {});
  }

  /* Interception du clic « Valider » : on ajoute l'upsell d'abord,
     puis on relance le clic pour que BB3 fasse son travail normal. */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-t-up]');
    if (t) { upChoisi = !upChoisi; rendre(); return; }
    var ch = e.target.closest('[data-t-chip]');
    if (ch) {
      if (ch.dataset.tChip === 'outil') { var o = $('outil'); if (o) o.click(); }
      else { upChoisi = !upChoisi; rendre(); }
      return;
    }
    if (e.target.closest('[data-t-pan]')) { panOuvert = !panOuvert; rendre(); return; }
    if (e.target.closest('#bb3 [data-t-intro]')) { intro(); return; }
    var btn = e.target.closest('#cta, #mcta');
    if (!btn || passe || UPS === '0' || btn.disabled) return;
    var s = etat(); if (!s.first || s.nb < (+C.upDes || 0)) return;
    if (UPS === 'C' && !upVu) {
      e.preventDefault(); e.stopImmediatePropagation(); upVu = true;
      feuille(function () { relancer(btn); });
      return;
    }
    if (upChoisi) { e.preventDefault(); e.stopImmediatePropagation(); relancer(btn); }
  }, true);
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-t-cb]')) { upChoisi = e.target.checked; rendre(); }
    if (e.target.matches('[data-t-case]')) {
      if (e.target.dataset.tCase === 'outil') { var o = $('outil'); if (o) o.click(); }
      else { upChoisi = e.target.checked; rendre(); }
    }
  });
  function relancer(btn) {
    (upChoisi ? ajouterUpsell() : Promise.resolve()).then(function () {
      passe = true; btn.click(); passe = false; upChoisi = false; upVu = false;
    });
  }

  /* ── Sélecteur de test (thème de test uniquement) ── */
  function switcher() {
    if (!C.switcher || $('t-sw')) return;
    var d = document.createElement('div'); d.id = 't-sw';
    function row(k, cur, lab) {
      return '<span>' + lab + '</span>' + ['A', 'B', 'C', '0'].map(function (v) {
        return '<button type="button" data-t-sw="' + k + '" data-v="' + v + '" class="' + (cur === v ? 'on' : '') + '">' + (v === '0' ? '–' : v) + '</button>';
      }).join('');
    }
    var vs = '<span>Version</span>' + [1, 2, 3, 4, 5, 6, 7, 8, 0].map(function (n) {
      return '<button type="button" data-t-sw="v" data-v="' + n + '" class="' + (V === n ? 'on' : '') + '">' + (n || '–') + '</button>';
    }).join('');
    var fs = (V === 7 || V === 8) ? '<div><span>Accueil</span>' + [1, 2, 3, 4].map(function (n) {
      return '<button type="button" data-t-sw="f" data-v="' + n + '" class="' + (F === n ? 'on' : '') + '">' + n + '</button>';
    }).join('') + '</div>' : '';
    d.innerHTML = '<div>' + vs + '</div>' + fs + (V ? '' : '<div>' + row('pal', PAL, 'Paliers') + '</div><div>' + row('ups', UPS, 'Upsell') + '</div>');
    root.insertBefore(d, root.firstChild);
    d.addEventListener('click', function (e) {
      var b = e.target.closest('[data-t-sw]'); if (!b) return;
      var u = new URL(location.href); u.searchParams.set(b.dataset.tSw, b.dataset.v);
      if (b.dataset.tSw === 'f' || b.dataset.tSw === 'v') u.searchParams.set('intro', '1');
      location.href = u.toString();
    });
  }

  /* ── Boucle : BB3 redessine → on repose nos éléments ── */
  var obs, prevu = false;
  function rendre() {
    if (obs) obs.disconnect();
    var s = etat();
    document.querySelectorAll('.t-cad-b, .t-sel-cad, .t-it').forEach(function (x) { x.remove(); });
    document.querySelectorAll('.t-cad').forEach(function (x) { x.classList.remove('t-cad'); });
    if (PAL !== '0') poserPaliers(s);
    if (UPS === 'A' || UPS === 'B') poserUpsell(s);
    else if (UPS === 'K') poserKit(s);
    root.setAttribute('data-t-pal', PAL); root.setAttribute('data-t-ups', UPS); root.setAttribute('data-t-v', V);
    if (window.BB3_MAJ_H) window.BB3_MAJ_H();
    if (obs) obs.observe(root, { childList: true, subtree: true });
  }
  function planifier() { if (prevu) return; prevu = true; setTimeout(function () { prevu = false; rendre(); }, 30); }

  function go() {
    switcher();
    rendre();
    if ((V === 7 || V === 8) && (q.get('intro') === '1' || lire('bb3t_intro', '') !== '1')) setTimeout(intro, 400);
    obs = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var t = muts[i].target;
        if (t.closest && t.closest('.t-up, .t-kit, #t-sw, .t-feuille')) continue;
        planifier(); return;
      }
    });
    obs.observe(root, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(go, 50); });
  else setTimeout(go, 50);
})();
